import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { InsufficientCreditsDialogComponent } from './insufficient-credits-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        RouterModule
    ],
    exports: [InsufficientCreditsDialogComponent],
    declarations: [InsufficientCreditsDialogComponent]
})
export class InsufficientCreditsDialogModule {}
